import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  url: string;
  @Input() set file(value: string) {
    this.url = value;
  }
  @Output() closeEvent = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  downloadPDF(): void {
    const filename = this.url.includes('?') ? this.url.slice(0, this.url.lastIndexOf("?")).substring(this.url.lastIndexOf('/') + 1):this.url.substring(this.url.lastIndexOf('/') + 1);
    const request = new XMLHttpRequest();
    request.open('GET', this.url, true);
    request.responseType = 'blob';
    request.onload = function () {
      if (this.status === 200) {
        var file = window.URL.createObjectURL(this.response);
        var a = document.createElement('a');
        a.href = file;
        a.download = filename || 'Attachment';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };
    request.send();
  }

  dismiss() {
    this.closeEvent.emit();
  }
}
